import { hasRole, isAdminNotConsultant, isHolding, isConsultantNotHolding } from "@/js/http/auth.js";
import AdminUserSubMenusLinks from "@/components/menu/sub-menus/users/AdminUserSubMenusLinks.vue";
import UserListComponent from "@/components/user/UserListComponent.vue";
import UserSignupLinkList from "@/components/user/UserSignupLinkList.vue";
export default {
  name: "adminUserList",
  components: {
    AdminUserSubMenusLinks: AdminUserSubMenusLinks,
    UserListComponent: UserListComponent,
    UserSignupLinkList: UserSignupLinkList
  },
  props: ["loggedUserData"],
  data: function data() {
    return {
      isAuthorized: false,
      canManage: false,
      selectedTab: null,
      tabs: {
        users: "users"
      }
    };
  },
  created: function created() {
    this.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
    this.isAuthorized = isAdminNotConsultant(this.loggedUserData) || isConsultantNotHolding(this.loggedUserData) || isHolding(this.loggedUserData);
    if (hasRole(process.env.VUE_APP_ROLES_MANAGE_USER_SIGN_UP_LINKS)) {
      this.tabs.signUpLink = "signUpLink";
    }
    this.selectedTab = this.$route.query.tab || this.tabs.users;
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isHolding: isHolding
  }
};